import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import Breadcrumb from '../../component/Breadcrumb';
import MappingDownloadTable from './table';
import { downloadMappedFile, fetchMappingTableData, syncUploadFileData } from '../../api/mappingApi';
import swal from 'sweetalert';
import Loader from '../../component/Loader/Loader';
import { Link } from 'react-router-dom';

const MappingFileDownload = () => {

  const [showLoader, setShowLoader]                   = React.useState(false);
  const [downloadMappingData, setDownloadMappingData] = React.useState([]);
  
  React.useEffect(() => {
    fetchData();
  },[])

  const fetchData = async () => {
    setShowLoader(true);
    const data = await fetchMappingTableData();
    setShowLoader(false);
    setDownloadMappingData(data);
  }


  const handleDownloadFile = async (rowId,fileName) => {
    setShowLoader(true);
    const response = await downloadMappedFile(rowId,fileName);
    if(response){
      const blob    = await response.blob();
      const url     = window.URL.createObjectURL(blob);
      const link    = document.createElement("a");
      link.href     = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    }
    setShowLoader(false);
  }

  const handleSyncMappedFile = async (rowId) => {
    setShowLoader(true);
    const result = await syncUploadFileData(rowId);
    setShowLoader(false);
    if(result){
      swal({
        title: "Success",
        text: result.message,
        icon: "success",
        closeOnClickOutside:false,
        closeOnEsc: false,
        allowOutsideClick: false,
      }).then(markedClose => {
        if (markedClose) {
          fetchData();
        }
      });
    }
  }

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb title="Download Mapping File">
        <Typography component={Link} to="/" variant="subtitle2"  color="primary" className="link-breadcrumb">
          Dashboard
        </Typography>
        <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
          Download Mapping
        </Typography>
      </Breadcrumb>
      <Box component="section">
        <Grid className="contentBox">
          <MappingDownloadTable 
            downloadMappingData   = {downloadMappingData} 
            handleDownloadFile    = {handleDownloadFile}  
            handleSyncMappedFile  = {handleSyncMappedFile}  
          />
        </Grid>
      </Box>
    </>
  );
};

export default MappingFileDownload;
